import "./Login.scss";

import {
  Box,
  CircularProgress,
  SvgIcon,
  Button,
  InputAdornment,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Background from "../../Assets/Images/loginimageAI.png";
import LoginLogos from "../../Assets/Images/Everest_Transparent_Logo.svg";

import { ReactComponent as ClosedEye } from "../../Assets/Images/closedEye.svg";
// import { ReactComponent as LoginLogo } from "../../Assets/Images/loginlogo.svg";
import { ReactComponent as MobileLoginLogo } from "../../Assets/Images/loginlogo.svg";
import { ReactComponent as LoginLogo } from "../../Assets/Images/Everest_Transparent_Logo.svg";

import { ReactComponent as OpenEye } from "../../Assets/Images/openEye.svg";
import Google from "../../Assets/Images/google.png";
import LockIcon from "../../Assets/Images/lock-02.svg";
import MailIcon from "../../Assets/Images/mail-01.svg";
import Facebook from "../../Assets/Images/facebook.png";
import AppleAi from "../../Assets/Images/AppleAi.png";

import { ReactComponent as Logmobile } from "../../Assets/Images/logomobile.svg";
import ButtonField from "../../Components/Button/ButtonField";
import { Link, useLocation, useNavigate } from "react-router-dom";
import IconButtonField from "../../Components/Button/IconButtonField";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import {
  clearLoginStatus,
  loginStart,
} from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { ILoginForm } from "./ILogin";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import TextInputFieldC from "../../Components/TextInput/TextInputFieldC";
import Snackbar from "../../Components/Snackbar/Snackbar";
import {
  AuthCredential,
  FacebookAuthProvider,
  fetchSignInMethodsForEmail,
  linkWithCredential,
  signInWithPopup,
} from "firebase/auth";
import {
  auth,
  facebookProvider,
  googleProvider,
} from "../../Components/FireBase/firebase";
import { decode } from "../../Utils/encodeDecode";
import {
  clearGoogleLoginStatus,
  GoogleloginStart,
} from "../../Redux/Slices/LoginSlicer/GoogleLoginSlicer";
import { EditStudentExamPractice } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import { EditStudentExam } from "../../Redux/Slices/StudentExam/EditStudentExamSlice";
// dialog
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import { clearRegistrationStatus } from "../../Redux/Slices/Registration/RegistrationSlicer";
import Cookies from "js-cookie";
import EmailIcon from "@mui/icons-material/Email";
const Login: React.FC = () => {
  // dialog
  const [open, setOpen] = React.useState(false);
  const { state: pathname } = useLocation();
  console.log(pathname);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    clearLoginStatus();
  };
  // -----

  const removeAllCookies = (): void => {
    const allCookies = Cookies.get();

    Object.keys(allCookies).forEach((cookieName) => {
      // Try removing from root path
      Cookies.remove(cookieName, { path: "/login" });

      // Also try removing without path (in case it was set differently)
      Cookies.remove(cookieName);
    });

    console.log("Cookies after removal:", Cookies.get()); // Debug output
  };
  const [show, setShow] = useState<boolean>(false);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const nav = useNavigate();
  const dispatch = useAppDispatch();

  const loginResponse = useAppSelector((state) => state.LoginSlicer);
  const GoogleloginResponse = useAppSelector(
    (state) => state.GoogleLoginSlicer
  );

  console.log(loginResponse, "login mesg`");
  const loginSchema = z.object({
    email: z
      .string({
        required_error: "Please enter a valid email ID",
        message: "Please enter a valid email ID",
      })
      .email({
        message: "Please enter a valid email ID",
      }),
    password: z.string({
      required_error: "Please enter password",
      message: "Please enter password",
    }),
  });
  const methods = useForm<ILoginForm>({
    defaultValues: {
      email: "",
      password: "",
    },
    resolver: zodResolver(loginSchema),
    mode: "onChange",
  });
  const onSubmit: SubmitHandler<ILoginForm> = (val) => {
    setIsSubmit(true);
    dispatch(loginStart(val));
    // sessionStorage.setItem("token", JSON.stringify(val));
    // nav("/dashboard");
  };

  useEffect(() => {
    const getToken = sessionStorage.getItem("token");
    const userDetails = decode(sessionStorage.getItem("details"));

    if (
      (loginResponse.data?.status && getToken) ||
      (GoogleloginResponse.data?.status && getToken)
    ) {
      const redirectPath = sessionStorage.getItem("redirectAfterLogin");

      if (redirectPath) {
        setTimeout(() => {
          nav(redirectPath);
        });

        sessionStorage.removeItem("redirectAfterLogin");
        return;
      }

      if (loginResponse.data?.data?.username) {
        sessionStorage.setItem("username", loginResponse.data.data.username);
      }

      if (userDetails.role === "ADMIN") {
        setTimeout(() => {
          nav("/admindashboard");
        }, 1000);
      } else if (userDetails.role === "TUTOR") {
        setTimeout(() => {
          nav("/tutor_dashboard");
        }, 1000);
      } else if (userDetails.role === "TUTOR_ADMIN") {
        setTimeout(() => {
          nav("/tutor_admin_dashboard");
        }, 1000);
      } else if (userDetails.role === "CRM_ADMIN") {
        setTimeout(() => {
          nav("/crm_dashboard");
        }, 1000);
      } else {
        if (pathname?.path === "minimock") {
          setTimeout(() => {
            nav("/mockexam");
          }, 1000);
        } else if (pathname?.path === "totalexam") {
          setTimeout(() => {
            nav("/totalexam");
          }, 1000);
        } else {
          setTimeout(() => {
            nav("/dashboard");
          }, 1000);
        }
      }
    }
    removeAllCookies();
  }, [loginResponse, GoogleloginResponse, nav]);

  // dialog
  useEffect(() => {
    if (loginResponse.data?.status === false) {
      setOpen(true);
    }
    removeAllCookies();
  }, [loginResponse]);
  // ---

  useEffect(() => {
    removeAllCookies();

    return () => {
      if (!isSubmit) {
        dispatch(clearLoginStatus());
        dispatch(clearRegistrationStatus());
        dispatch(clearGoogleLoginStatus());
      }
    };
  }, []);

  const PendingTime = sessionStorage.getItem("pending_time");
  const Response = sessionStorage.getItem("response");
  const question_id = Number(sessionStorage.getItem("question_id"));
  const Question_Type = Number(sessionStorage.getItem("question_type"));
  const StudentExamId = Number(sessionStorage.getItem("student_exam_id"));
  const redirectPath = sessionStorage.getItem("redirectAfterLogin");
  const loginResponsereg = useAppSelector((state) => state.RegistrationSlicer);

  useEffect(() => {
    dispatch(
      EditStudentExamPractice({
        pending_time: PendingTime,
        student_test_id: StudentExamId,
        question_type_id: Question_Type,
        question_id: question_id,
        response: Response,
      })
    );
    dispatch(
      EditStudentExam({
        pending_time: PendingTime,
        student_exam_id: StudentExamId,
        question_type_id: Question_Type,
        question_id: question_id,
        sentence: Response,
      })
    );
    sessionStorage.removeItem("pending_time");
    sessionStorage.removeItem("response");
    sessionStorage.removeItem("question_id");
    sessionStorage.removeItem("question_type");
    sessionStorage.removeItem("student_exam_id");
    sessionStorage.clear();

    console.log("Cookies before removal:", Cookies.get()); // Debug output
    removeAllCookies();

    if (redirectPath) {
      sessionStorage.setItem("redirectAfterLogin", redirectPath);
    }
    console.log("Cookies After removal:", Cookies.get()); // Debug output
  }, [dispatch]);

  // Google login function
  const googleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user: any = result.user;

      if (user) {
        dispatch(GoogleloginStart({ token: user?.accessToken, islogin: true }));
      }
    } catch (error: any) {
      console.error("Login failed:", error);

      // Extract error message
      const errorMessage =
        error.code === "auth/unauthorized-domain"
          ? "Login failed: Unauthorized domain. Please contact support."
          : "Login failed: " +
            (error.message || "An unexpected error occurred.");
    }
  };

  // facebook

  const signInWithFacebook = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      const user: any = result.user;
      console.log(user, "user");
      dispatch(GoogleloginStart({ token: user?.accessToken, islogin: true }));
    } catch (error: any) {
      console.log(error, "error facebook");
    }
  };

  //   const signInWithApple = async () => {
  //   try {
  //     const provider = new OAuthProvider('apple.com');
  //     provider.addScope('email');
  //     provider.addScope('name');

  //     const result = await signInWithPopup(auth, provider);
  //     const user: any = result.user;

  //     const credential = OAuthProvider.credentialFromResult(result);
  //     const token = credential?.idToken;

  //     console.log(user, "user");
  //     console.log(token, "apple id token");

  //     dispatch(GoogleloginStart({ token: token, islogin: true }));
  //   } catch (error: any) {
  //     console.error("Apple sign-in error:", error);
  //   }
  // };

  return (
    <>
      <div className="parent-div">
        <Snackbar
          titleSx={{ color: "white" }}
          response={
            Object.keys(loginResponse.data || {}).length === 0
              ? GoogleloginResponse.data
              : loginResponse.data
          }
        />
        <Snackbar
          response={
            Object.keys(loginResponsereg.data || {}).length === 0
              ? GoogleloginResponse.data
              : loginResponsereg.data
          }
        />

        {/* <div className="child-div1s"></div> */}
        <div className="child-div1s">
          <img
            src={Background}
            alt="AI Robot Scene"
            className="responsive-image"
          />
          <div
            className=" absolute flex items-center justify-center"
            style={{
              borderRadius: "10px",
              // boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="p-[32px] W-[50%] text-center bg-white/20 backdrop-blur-md rounded-lg border border-white/30 shadow-lg ">
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  mb: 1,
                  textShadow: "0 1px 2px rgba(0,0,0,0.4)",
                  fontSize: "30px",
                }}
              >
                Welcome Back
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "white",
                  fontSize: "20px",
                  textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                  marginTop: "10px",
                }}
              >
                Continue your learning journey today!
              </Typography>
            </div>
          </div>
        </div>

        <div className="child-div2">
          <div className="form-content">
            <FormProvider {...methods}>
              <form
                onSubmit={methods.handleSubmit(onSubmit)}
                style={{ display: "flex", justifyContent: "center" }}
                autoComplete="off"
              >
                <div className="main">
                  <div>
                    <div className="heading">
                      <SvgIcon
                        sx={{
                          width: "64%",
                          height: "100%",
                          padding: "15px",
                        }}
                        component={LoginLogo}
                        inheritViewBox
                        onClick={() => {
                          nav("/home");
                        }}
                      />
                    </div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: "1.9rem",
                        textAlign: "center",
                      }}
                    >
                      Login{" "}
                    </div>

                    <div className="subHeadingss">
                      Enter your email below to login to your account{" "}
                    </div>
                  </div>
                  {/* Social Logins */}
                  <div style={{ textAlign: "center", margin: "15px 0" }}>
                    <ButtonField
                      sx={{
                        marginBottom: "10px",
                        cursor: "pointer",
                        border: "1px solid #64748b",
                        borderRadius: "10px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600,
                        maxWidth: "100%",
                        width: "100%",
                        fontSize: "14px",
                        color: "black",
                      }}
                      onClick={googleLogin}
                    >
                      {/* <SvgIcon
                        sx={{ verticalAlign: "middle", marginRight: "8px" }}
                        component={Google}
                        inheritViewBox
                      /> */}
                      <img
                        src={Google}
                        alt="AI Robot Scene"
                        style={{ width: "30px" }}
                      />
                      Login with Google
                    </ButtonField>
                    <ButtonField
                      sx={{
                        marginBottom: "10px",
                        backgroundColor: "#1877F2",
                        color: "white",
                        cursor: "pointer",
                        borderRadius: "10px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600,
                        maxWidth: "100%",
                        width: "100%",
                        fontSize: "14px",
                        "&:hover": {
                          backgroundColor: "#145dbf",
                        },
                      }}
                      onClick={signInWithFacebook}
                    >
                      {/* <SvgIcon
                        sx={{ verticalAlign: "middle", marginRight: "8px" }}
                        component={Facebook}
                        inheritViewBox
                      /> */}
                      <img
                        src={Facebook}
                        alt="AI Robot Scene"
                        style={{
                          width: "25px",
                          height: "25px",
                          color: "white",
                          marginRight: "10px",
                        }}
                      />
                      Login with Facebook
                    </ButtonField>
                    {/* <div
                      style={{
                        marginBottom: "10px",
                        cursor: "pointer",
                        borderRadius: "10px",
                        backgroundColor: "#373737",
                        color: "white",
                        fontWeight: 600,

                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={signInWithApple}
                    >
                     
                      <img
                        src={AppleAi}
                        alt="AI Robot Scene"
                        style={{
                          width: "15px",
                          color: "white",
                          marginRight: "10px",
                        }}
                      />
                      Login with Apple
                    </div> */}
                  </div>

                  {/* Divider */}
                  <div
                    style={{
                      textAlign: "center",
                      margin: "15px 0",
                      borderTop: "1px solid #ccc",
                      lineHeight: "0.1em",
                    }}
                  >
                    <span
                      style={{
                        background: "#fff",
                        color: "#64748b",
                        padding: "0 10px",
                      }}
                    >
                      OR CONTINUE WITH
                    </span>
                  </div>

                  {/* Email + Password */}

                  <div className="textFields">
                    <Typography sx={{ fontSize: 15, fontWeight: 600, mb: 1 }}>
                      Email
                    </Typography>

                    <TextInputFieldC
                      placeholder="Enter your email"
                      name="email"
                      type="email"
                      className="textField"
                      variant="outlined"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src={MailIcon}
                              alt="Email Icon"
                              style={{ width: 20, height: 20 }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {/* Forgot Password */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          marginTop: "10px",
                          fontSize: "15px",
                          fontWeight: 600,
                        }}
                      >
                        Password
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          fontSize: "15px",
                          marginTop: "8px",
                        }}
                      >
                        <Link
                          to="/forgotPassword"
                          style={{ color: "#009DFF", textDecoration: "none" }}
                        >
                          Forgot password?
                        </Link>
                      </div>
                    </div>
                    <TextInputFieldC
                      name="password"
                      placeholder="Enter your password"
                      className="textField"
                      type={show ? "text" : "password"}
                      variant="outlined"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src={LockIcon}
                              alt="Lock Icon"
                              style={{ width: 20, height: 20 }}
                            />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButtonField onClick={() => setShow(!show)}>
                              <SvgIcon
                                sx={{
                                  width: "20px",
                                  height: "20px",
                                  color: "white",
                                }}
                                component={show ? OpenEye : ClosedEye}
                                inheritViewBox
                              />
                            </IconButtonField>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  {/* Sign In Button */}
                  <div className="textFields" style={{ marginTop: "20px" }}>
                    <ButtonField
                      className="buttonfield"
                      type="submit"
                      disabled={loginResponse.isLoading}
                    >
                      Sign in
                      {loginResponse.isLoading && (
                        <CircularProgress
                          size={24}
                          sx={{
                            color: "white",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            marginTop: "-12px",
                            marginLeft: "-12px",
                          }}
                        />
                      )}
                    </ButtonField>
                  </div>

                  {/* Sign Up */}
                  <div
                    className="subHeadingss"
                    style={{ textAlign: "center", marginTop: "15px" }}
                  >
                    Don't have an account?
                    <Link
                      to="/registration"
                      onClick={() => dispatch(clearRegistrationStatus())}
                      style={{
                        color: "#009DFF",
                        paddingLeft: "5px",
                        fontSize: "15px",
                        textDecoration: "none",
                      }}
                    >
                      Sign up
                    </Link>
                  </div>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>

      <div className="backGroundbackground">
        {/* <Snackbar response={loginResponse.data} /> */}
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            style={{ display: "flex", justifyContent: "center" }}
            autoComplete="off"
          >
            <div className="main">
              <div>
                <div className="heading">
                  <SvgIcon
                    sx={{
                      width: "70%",
                      height: "70%",
                      padding: "15px",
                      cursor: "pointer",
                    }}
                    component={MobileLoginLogo}
                    inheritViewBox
                    onClick={() => {
                      nav("/dashboard");
                    }}
                  />
                </div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "1.9rem",
                    textAlign: "center",
                  }}
                >
                  Login{" "}
                </div>

                <div className="subHeadingss">
                  Enter your email below to login to your account{" "}
                </div>
              </div>
              {/* Social Logins */}
              <Box
                style={{ textAlign: "center", margin: "15px 0" }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <ButtonField
                  sx={{
                    marginBottom: "10px",
                    cursor: "pointer",
                    border: "1px solid #64748b",
                    borderRadius: "10px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 600,
                    width: "100%",
                  }}
                  onClick={googleLogin}
                >
                  {/* <SvgIcon
                        sx={{ verticalAlign: "middle", marginRight: "8px" }}
                        component={Google}
                        inheritViewBox
                      /> */}
                  <img
                    src={Google}
                    alt="AI Robot Scene"
                    style={{
                      width: "20px",
                      color: "white",
                      marginRight: "10px",
                    }}
                  />
                  Login with Google
                </ButtonField>
                <ButtonField
                  sx={{
                    marginBottom: "10px",
                    backgroundColor: "#1877F2",
                    color: "white",
                    cursor: "pointer",
                    borderRadius: "10px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    fontWeight: 600,
                    "&:hover": {
                      backgroundColor: "#145dbf",
                    },
                  }}
                  onClick={signInWithFacebook}
                >
                  {/* <SvgIcon
                        sx={{ verticalAlign: "middle", marginRight: "8px" }}
                        component={Facebook}
                        inheritViewBox
                      /> */}
                  <img
                    src={Facebook}
                    alt="AI Robot Scene"
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "white",
                      marginRight: "10px",
                    }}
                  />
                  Login with Facebook
                </ButtonField>
                {/* <div
                  style={{
                    marginBottom: "10px",
                    cursor: "pointer",
                    borderRadius: "10px",
                    backgroundColor: "#373737",
                    color: "white",
                    fontWeight: 600,

                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  
                  <img
                    src={AppleAi}
                    alt="AI Robot Scene"
                    style={{
                      width: "15px",
                      color: "white",
                      marginRight: "10px",
                    }}
                  />
                  Login with Apple
                </div> */}
              </Box>

              {/* Divider */}
              <div
                style={{
                  textAlign: "center",
                  margin: "15px 0",
                  borderTop: "1px solid #ccc",
                  lineHeight: "0.1em",
                }}
              >
                <span
                  style={{
                    background: "#fff",
                    color: "#64748b",
                    padding: "0 10px",
                  }}
                >
                  OR CONTINUE WITH
                </span>
              </div>

              {/* Email + Password */}

              <div className="textFields">
                <Typography sx={{ fontSize: 15, fontWeight: 600, mb: 1 }}>
                  Email
                </Typography>

                <TextInputFieldC
                  placeholder="Enter your email"
                  name="email"
                  type="email"
                  className="textField"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={MailIcon}
                          alt="Email Icon"
                          style={{ width: 20, height: 20 }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Forgot Password */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      marginTop: "10px",
                      fontSize: "15px",
                      fontWeight: 600,
                    }}
                  >
                    Password
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      fontSize: "15px",
                      marginTop: "8px",
                    }}
                  >
                    <Link
                      to="/forgotPassword"
                      style={{ color: "#009DFF", textDecoration: "none" }}
                    >
                      Forgot password?
                    </Link>
                  </div>
                </div>
                <TextInputFieldC
                  name="password"
                  placeholder="Enter your password"
                  className="textField"
                  type={show ? "text" : "password"}
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={LockIcon}
                          alt="Lock Icon"
                          style={{ width: 20, height: 20 }}
                        />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButtonField onClick={() => setShow(!show)}>
                          <SvgIcon
                            sx={{
                              width: "20px",
                              height: "20px",
                              color: "white",
                            }}
                            component={show ? OpenEye : ClosedEye}
                            inheritViewBox
                          />
                        </IconButtonField>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              {/* Sign In Button */}
              <div className="textFields" style={{ marginTop: "20px" }}>
                <ButtonField
                  className="buttonfield"
                  type="submit"
                  disabled={loginResponse.isLoading}
                >
                  Sign in
                  {loginResponse.isLoading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: "white",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </ButtonField>
              </div>

              {/* Sign Up */}
              <div
                className="subHeadingss"
                style={{ textAlign: "center", marginTop: "15px" }}
              >
                Don't have an account?
                <Link
                  to="/registration"
                  onClick={() => dispatch(clearRegistrationStatus())}
                  style={{
                    color: "#009DFF",
                    paddingLeft: "5px",
                    fontSize: "15px",
                    textDecoration: "none",
                  }}
                >
                  Sign up
                </Link>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default Login;
